export enum CircuitStepDaytime {
  Breakfast = 'Breakfast',
  Morning = 'Morning',
  Lunch = 'Lunch',
  Afternoon = 'Afternoon',
  Dinner = 'Dinner',
  Evening = 'Evening',
  Night = 'Night',
}

const enumValues = [
  CircuitStepDaytime.Breakfast,
  CircuitStepDaytime.Morning,
  CircuitStepDaytime.Lunch,
  CircuitStepDaytime.Afternoon,
  CircuitStepDaytime.Dinner,
  CircuitStepDaytime.Evening,
  CircuitStepDaytime.Night,
];

export const CircuitStepDayTimeIndexes = enumValues.reduce(
  (acc, value, index) => {
    acc[value] = index;
    return acc;
  },
  {} as Record<CircuitStepDaytime, number>,
);

export const compareCircuitStepDayTime = (
  value1: CircuitStepDaytime,
  value2: CircuitStepDaytime,
) => {
  const index1 = CircuitStepDayTimeIndexes[value1];
  const index2 = CircuitStepDayTimeIndexes[value2];

  return index1 - index2;
};
